module.exports = __webpack_public_path__ + "static/media/dice_2.dacafa5b.svg";